import { AiSuggestion, AiSuggestionReview, NamedItemInt } from '../../../index'
import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/pagedList'
import { ExtractExpenseDataFromFileV2 } from '../expenses/expenseDetails'

export type AiAnalyticsFilter = OrderedPageFilter & {
  aiSuggestionReview: AiSuggestionReview | null
  expenseTypeId: number | null
  aiSuggestion: AiSuggestion | null
  reviewedOnly: boolean
  startDate?: string
  ineligibleExpenses: boolean
  selectedExpenseTypeId: number | null
  date: boolean
  notDate: boolean
  amount: boolean
  notAmount: boolean
  rx: boolean
  notRx: boolean
  hsa: boolean
  notHsa: boolean
  dateAndAmount: boolean
  notDateAndAmount: boolean
  amountAndRx: boolean
  notAmountAndRx: boolean
  verified: boolean
  notVerified: boolean
  eyeByeDirect: boolean
  notEyeByeDirect: boolean
  one800Contact: boolean
  notOne800Contact: boolean
  copay: boolean
  notCopay: boolean
  suggestionDuplicate: boolean
  notSuggestionDuplicate: boolean
  autoVerified: boolean
  notAutoVerified: boolean
  notVerifiedReason: boolean
  noReason: boolean
}
export type AiAnalyticsResponse = {
  expenseId: string
  expenseNumber: number
  aiSuggestionReview: AiSuggestionReview
  requestedAmount: number
  dateOfService: string
  lastReviewAt: string
  serviceProvider: string
  receiverName: string
  expenseType: string
  aiSuggestion: NamedItemInt
  isAutoVerified: boolean
  attachments: AttachmentForExpenseResponse[]
}
export type AttachmentForExpenseResponse = {
  filename: string
  jsonFileName: string
  title: string
  createdAt: string
  duplicatedExpenseNumber: number | null
  notVerifiedReason: NamedItemInt
  extractExpenseDataFromFile: ExtractExpenseDataFromFileV2
}

const getAiAnalytics = (filter?: AiAnalyticsFilter): Promise<PagedList<AiAnalyticsResponse>> => {
  filter = filter || {
    aiSuggestionReview: null,
    aiSuggestion: null,
    expenseTypeId: null,
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'expenseNumber',
    orderDescending: true,
    reviewedOnly: false,
    ineligibleExpenses: false,
    selectedExpenseTypeId: null,
    date: false,
    notDate: false,
    amount: false,
    notAmount: false,
    rx: false,
    notRx: false,
    hsa: false,
    notHsa: false,
    dateAndAmount: false,
    notDateAndAmount: false,
    amountAndRx: false,
    notAmountAndRx: false,
    verified: false,
    notVerified: false,
    eyeByeDirect: false,
    notEyeByeDirect: false,
    one800Contact: false,
    notOne800Contact: false,
    copay: false,
    notCopay: false,
    suggestionDuplicate: false,
    notSuggestionDuplicate: false,
    autoVerified: false,
    notAutoVerified: false,
    notVerifiedReason: false,
    noReason: false,
  }
  return adminHttpClient.get('/DocReview/ExpensesInfoForAiAnalytics', filter)
}

export default getAiAnalytics
